import {each, filter, findWhere, flatten, isEmpty, keys, map, uniq} from "underscore";

export const processExactKeyValuePairSettings = (organizationSettings, settings) => {
  if (isEmpty(organizationSettings)) {
    return {};
  }

  const keyValuePairSettings = {};
  each(settings, (key) => {
    const setting = findWhere(organizationSettings, {key});
    keyValuePairSettings[key] = setting?.value;
    keyValuePairSettings[`${key}Setting`] = setting;
  });
  return keyValuePairSettings;
};

export const processTrueFalseSettings = (organizationSettings, settings) => {
  if (isEmpty(organizationSettings)) {
    return {};
  }

  const trueFalseSettings = {};
  each(settings, (key) => {
    const setting = findWhere(organizationSettings, {key});
    trueFalseSettings[key] = setting?.value === "true" || setting?.value === true;
    trueFalseSettings[`${key}Setting`] = setting;
  });
  return trueFalseSettings;
};

export const processFormSwitchGroupSettings = (settings) => {
  const formSwitchSettings = {};
  each(settings, (permissionSetting) => {
    formSwitchSettings[permissionSetting.name] = permissionSetting.defaultChecked;
  });
  return formSwitchSettings;
};

export const processJsonObjectSettings = (setting) => {
  if (!setting?.value) {
    return {};
  }

  const jsonObjectSettings = JSON.parse(setting.value);
  each(keys(jsonObjectSettings), (key) => {
    jsonObjectSettings[key] =
      jsonObjectSettings[key] === true || jsonObjectSettings[key] === "true";
  });
  return jsonObjectSettings;
};

export const camelCaseToLabel = (camelCase) =>
  camelCase
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (s) => s.toUpperCase())
    .trim();

export const processJsonFlagsSettings = (setting) => {
  const obj = processJsonObjectSettings(setting);

  return map(
    filter(keys(obj), (key) => obj[key]),
    (key) => ({
      name: camelCaseToLabel(key),
      value: key,
    }),
  );
};

export const toJsonFlags = (selectedValues, allValues) => {
  const flags = {};

  for (const {value} of allValues) {
    flags[value] = false;
  }

  for (const {value} of selectedValues) {
    flags[value] = true;
  }

  return flags;
};

export const processJsonFlagsValues = (...settings) => {
  const objs = map(settings, processJsonObjectSettings);
  const allKeys = uniq(flatten(map(objs, (obj) => keys(obj))));

  return map(allKeys, (key) => ({
    name: camelCaseToLabel(key),
    value: key,
  }));
};

export const processRolesAndUsersSettings = (setting) => {
  if (!setting?.value) {
    return {roles: [], users: []};
  }
  const parsedSetting = JSON.parse(setting.value);
  return {
    roles: parsedSetting.roles,
    users: parsedSetting.users,
  };
};

export const processIdsSettings = (setting) => {
  if (!setting?.value) {
    return [];
  }
  return JSON.parse(setting.value);
};
